// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_3C4Td","title":"title_35nAp","desc":"desc_3ExE0"};